<template>
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>车证管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">车证管理</div>
        <Input search placeholder="请输入公司名/姓名" v-model="searchField" @on-search="searchPro()" style="width:230px;margin-top:20px;" />
        <!--                <Input-->
        <!--                        search-->
        <!--                        placeholder="请输入联系人名"-->
        <!--                        v-model="searchField"-->
        <!--                        @on-search="searchPro()"-->
        <!--                        style="width:230px;margin-top:20px;"-->
        <!--                />-->
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="exportExcel()">
          <i class="icon iconfont icon-downLoad2"></i>
          <span>导出车证</span>
        </div>
      </div>
    </div>
    <hostCarManageItem ref="hostCarManageItem" :searchField="searchField" />
  </div>
</template>

<script>
import hostCarManageItem from "../components/host-carmanage-item.vue";
import { mapGetters, mapActions, mapMutations } from "vuex"; 

export default {
  name: "host-product",
  data() {
    return {
      company: null,
      editId: "",
      addBrandflag: false,
      showTabs: "1",
      searchField: "", // 搜索关键字
    };
  },
  components: {
    hostCarManageItem,
  },
  async created() {},
  computed: {
    ...mapGetters({
      exhibitionInfo: "hostSetModule/getHostExhibition",
    }),
    query() {
      return this.$route.query;
    },
    option() {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "compId",
                  Value: `%${this.editId}%`,
                },
              },
            ],
          },
        },
      };
    },
    // exhibitionInfo() {
    //     if (JSON.parse(localStorage.vuex)) {
    //         return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
    //     }
    // }
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      getCarExcel: "hostSetModule/getCarExcel",
    }),
    searchPro() {
      this.$refs.hostCarManageItem.init();
    },
    downloadList() {
      this.$refs.exhibitionProductApply.exportInfo();
    },
    //导出车证
    async exportExcel() {
      let opt = {
        pageSize: 10000,
        pageIndex: 1,
        exhibitionId: this.exhibitionInfo.id,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 1,
            Predicates: [{}],
          },
        },
      };
      if (this.searchField) {
        opt.Wheres.wheres.Predicates.push(
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "contactName",
              Value: `%${this.searchField}%`,
            },
          },
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "companyName",
              Value: `%${this.searchField}%`,
            },
          }
        );
      }
      let data = await this.getCarExcel(opt);
      // if (data && data.items && data.items.length) {
      //     const exData = this.transformData(data.items);
      //     require.ensure([], () => {
      //         const {
      //             export_json_to_excel
      //         } = require("../../../../../assets/js/Export2Excel"); //这个地址和页面的位置相关，这个地址是Export2Excel.js相对于页面的相对位置
      //         const tHeader = ["姓名", "公司", "职务", "手机", "地区", "注册时间"]; // 表头
      //         const filterVal = ["name", "compName", "jobTitle", "phoneNumber", "address", "time"]; // 数据
      //         const data = this.formatJson(filterVal, exData);
      //         export_json_to_excel(tHeader, data, "用户"); //列表excel  这个是导出表单的名称
      //     });
      // } else {
      //     this.$Message.warning("暂无用户数据！");
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.eb-top-r {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;
  &-box {
    width: 148px;
    height: 78px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      border: 1px dashed #1890ff;
      transition: 0.5s;
    }
    .I1 {
      font-size: 16px;
      font-weight: bold;
      color: #1890ff;
    }
    .s3 {
      font-size: 14px;
      color: #1890ff;
      margin-left: 9px;
    }
  }
}
</style>
